import React, { useState } from 'react';

/**
 * Comparison Helper Component
 * Umožňuje rychlý výběr období a typu srovnání
 */
export default function ComparisonHelper({ onSelect }) {
  const [expanded, setExpanded] = useState(false);

  const presets = [
    {
      label: 'Tento týden vs minulý týden',
      query: 'Porovnej tento týden s minulým týdnem',
      icon: 'date_range'
    },
    {
      label: 'Posledních 14 dní vs předchozích 14 dní',
      query: 'Porovnej posledních 14 dní s předchozími 14 dny',
      icon: 'trending_up'
    },
    {
      label: 'Tento měsíc vs minulý měsíc',
      query: 'Porovnej tento měsíc s minulým měsícem',
      icon: 'calendar_month'
    },
    {
      label: 'Dnes vs včera',
      query: 'Porovnej dnes se včerejškem',
      icon: 'today'
    },
    {
      label: 'Tento měsíc vs stejný měsíc loni',
      query: 'Porovnej tento měsíc se stejným měsícem loni',
      icon: 'autorenew'
    }
  ];

  const handleSelect = (preset) => {
    onSelect(preset.query);
    setExpanded(false);
  };

  return (
    <div>
      <button
        className="w-full bg-background-light dark:bg-background-dark border border-border-light dark:border-border-dark px-4 py-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors flex items-center gap-2 text-sm font-semibold text-primary"
        onClick={() => setExpanded(!expanded)}
      >
        <span className="material-symbols-outlined text-lg">compare_arrows</span>
        <span className="flex-1 text-left">Rychlé srovnání</span>
        <span className="material-symbols-outlined text-sm transition-transform duration-200" style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          expand_more
        </span>
      </button>

      {expanded && (
        <div className="mt-2 space-y-2 animate-in slide-in-from-top-2 duration-200">
          {presets.map((preset, idx) => (
            <button
              key={idx}
              className="w-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark px-4 py-3 rounded-lg hover:bg-primary hover:text-white hover:border-primary transition-all flex items-center gap-3 text-left"
              onClick={() => handleSelect(preset)}
            >
              <span className="material-symbols-outlined text-xl flex-shrink-0">
                {preset.icon}
              </span>
              <span className="flex-1 font-medium text-sm">{preset.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
